/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";
//custom libraries
import { initParams, ParamsJson } from "../hooks/use-sale-form";

export const ParamsSalesContext: React.Context<any> = createContext(null);
export const ParamsSalesProvider = ({ children }: any) => {
  const [params, setParams] = useState<ParamsJson | any>(initParams);

  return (
    <ParamsSalesContext.Provider value={{ params, setParams }}>
      {children}
    </ParamsSalesContext.Provider>
  );
};

export const useParamsSalesValue = () => useContext(ParamsSalesContext);
